import React, { useRef } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import ScrollArrowButtons from "../../common/ScrollArrowButtons";
import { assets } from "../../../Assets/assets";
import itServices from "../../../config/itServices.json"
import { Link } from "react-router-dom";

const ItSolutions = () => {
  const scrollRef = useRef(null);

  const solutionData = [
    { img: assets.solutioncardimg1, text: "Statement of Work" },
    { img: assets.solutioncardimg2, text: "Build your IT Team" },
    { img: assets.solutioncardimg3, text: "System Integration" },
  ];

  const scrollLeft = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  return (
    <section
      className="relative w-full bg-cover bg-center"
      style={{ backgroundImage: `url(${assets.solutionlayout1})` }}
    >
      <div className="mx-auto max-w-[1400px] grid grid-cols-1 lg:grid-cols-3 items-baseline gap-5 px-6 xl:py-20 py-14 text-white">

        <article data-aos="fade-up-right" data-aos-duration="1000" className="space-y-4">
          <h1 className="text-3xl xl:text-4xl font-bold tracking-wide">IT Solutions</h1>
          <p className="text-sm xl:text-[16px] text-justify md:text-left leading-relaxed opacity-90">
            That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients.
          </p>

          <Link to={'/aboutus'}>
            <button className="px-8 py-3 mt-3 bg-primaryFadedColor text-white font-semibold rounded-md shadow-md hover:bg-primaryColor flex gap-2 items-center group transition-all duration-500">
              Explore
              <FaArrowRightLong className="transition-transform duration-500 group-hover:translate-x-2" />
            </button>
          </Link>
        </article>

        <div className="col-span-2">
          <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-end gap-2">
            <ScrollArrowButtons scrollLeft={scrollLeft} scrollRight={scrollRight} color={true} />
          </div>
          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto no-scrollbar snap-mandatory py-6 snap-x"
          >
            {itServices.map((s, index) => (
              <Link data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} to={`/itsolutions/${s.id}`}
                key={index}
                className="relative w-full inline-block md:w-[21rem] lg:w-[270px] shrink-0 xl:min-w-[280px] h-[300px] md:h-[340px] xl:h-[380px] rounded-xl overflow-hidden cursor-pointer snap-center group"
              >
                <img
                  src={solutionData[index].img}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>

                <h2 className="absolute bottom-6 left-6 text-lg xl:text-xl font-semibold text-white transition-all duration-500 group-hover:translate-x-2">
                  {s.servieName}
                </h2>
              </Link>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ItSolutions;
